module.exports = __webpack_public_path__ + "media/images/brand/lander/background-d5c07bb7965f532c75d0a8cf4658380b.jpg";